import { Component, ViewChild, OnInit } from '@angular/core';
import { UninstallDonationModal } from './uninstall-donation.modal';
import { ListItem } from '@lmnop/web-core';
import { FormControl, FormArray } from '@angular/forms';
import { UninstallModel } from './uninstall-model.class';
import { ExtendedFormGroup } from '@lmnop/angular-core';
import { NgxSpinnerService } from 'ngx-spinner';
import { PageBase } from '../../base/page-base/page-base.component';

@Component({
    templateUrl: './uninstall.page.html',
    standalone: false,
})
export class UninstallPage extends PageBase implements OnInit {
    constructor(protected override spinnerService: NgxSpinnerService) {
        super(spinnerService);
        this.initFormGroup();
    }

    @ViewChild('uninstallDonationModal', { static: true })
    private uninstallDonationModal: UninstallDonationModal;

    public reasons: ListItem[] = [];
    public formGroup: ExtendedFormGroup<UninstallModel>;

    public surveyAnswered: boolean = false;

    async ngOnInit(): Promise<void> {
        this.uninstallDonationModal.openModal();
        this.initFormGroup();

        $.ajax({
            url: this.ioc.core.utils.getApiUrl(
                'api/uninstall/GetUninstallReasonList'
            ),
            type: 'POST',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            success: (res: ListItem[]) => {
                res.asyncForEach(async (item: ListItem): Promise<void> => {
                    item.text = await this.ioc.core.translation.getMessage(
                        'uninstall_reasons.' + item.value.toString()
                    );
                });
                this.reasons = res;
            },
            error: (error: any) => {
                if (error && error.error && error.error.message) {
                    this.ioc.core.notificationService.createWarningTranslateMessage(
                        'error_messages.' + error.error.message
                    );
                }
            },
        });
        this.initReasonsFormArray();
    }

    private initFormGroup(): void {
        this.formGroup = new ExtendedFormGroup(
            'uninstall-form',
            UninstallModel,
            {
                otherReason: new FormControl(''),
                reasons: new FormArray([]),
            }
        );
    }

    private createReason(): FormControl {
        const formControl: FormControl = new FormControl(false);
        return formControl;
    }

    private initReasonsFormArray(): void {
        let formArray: FormArray = <FormArray>this.formGroup.get('reasons');
        for (let i: number = 0; i < this.reasons.length; i++) {
            formArray.push(this.createReason());
        }
    }

    public save(): void {
        const selectedReasons: ListItem[] = [];
        //TODO NOW: EXTENSION megnézni hogy működik extended formgroup-al
        /*this.formGroup.getValue().reasons
            .map((v: string, i: number): ListItem => (v ? this.reasons[i] : null))
            .filter((v: string): boolean => v !== null);*/

        //TODO NOW: EXTENSION ez a coreservice-be mentse, mert minden extension oda fogja menteni
        let res: UninstallModel = this.formGroup.getValue();
        res.reasons = selectedReasons;

        let postUrl = this.ioc.core.utils.getApiUrl(
            'api/uninstall/SaveUninstallReason'
        );
        $.ajax({
            url: postUrl,
            type: 'POST',
            data: JSON.stringify(res),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            success: response => {
                this.surveyAnswered = true;
            },
            error: (error: any) => {
                if (error && error.error && error.error.message) {
                    this.ioc.core.notificationService.createWarningTranslateMessage(
                        'error_messages.' + error.error.message
                    );
                }
            },
        });
    }
}
